import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/auth';
import { format } from 'date-fns';

export const useTodaysRegistrations = () => {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    if (!user) return;

    const fetchTodaysCount = async () => {
      setIsLoading(true);

      try {
        const today = new Date();
        const dateString = format(today, 'yyyy-MM-dd');
        const startDate = `${dateString}T00:00:00.000Z`;
        const endDate = `${dateString}T23:59:59.999Z`;

        // Count unique registrations (individual usage records + group sessions)
        const { data, error } = await supabase
          .from('usage_records')
          .select('group_session_id')
          .eq('user_id', user.id)
          .gte('date', startDate)
          .lte('date', endDate);

        if (error) throw error;

        // Count unique sessions: count group sessions as 1 and individual records as 1 each
        const groupSessions = new Set();
        let individualRecords = 0;

        (data || []).forEach(record => {
          if (record.group_session_id) {
            groupSessions.add(record.group_session_id);
          } else {
            individualRecords++;
          }
        });

        const totalRegistrations = groupSessions.size + individualRecords;
        setCount(totalRegistrations);
      } catch (err: any) {
        console.error('Error fetching today\'s registrations count:', err);
        setCount(0);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTodaysCount();
  }, [user]);

  return {
    count,
    isLoading
  };
};